import { Spin, Result } from "antd"

export type Props = {
    state: 'uploading' | 'success' | 'error',
    numberUpdated: number,
    attributesUpdated: string[]
}

const naturalLanguageList = (attributes: string[]) => {
    if (attributes.length === 0) {
        return "only default fields"
    }
    if (attributes.length < 2) {
        return attributes[0]
    }
    if (attributes.length === 2) {
        return `${attributes[0]} and ${attributes[1]}`
    }
    return attributes.map((x: string, i: number) => i === attributes.length -1 ? `and ${x}` : x).join(', ')
}

export const UploadFeedback = ({ state, numberUpdated = 0, attributesUpdated = [] }: Props) => {
    if (state === 'success') {
        return <Result status="success" title="Congratulations!" subTitle={<>{numberUpdated} items have been successfully updated.<br/>We updated {naturalLanguageList(attributesUpdated)} on each item.</>}/>
    }
    if (state === 'error') {
        return <Result status="error" title="Uh oh!" subTitle={<>This update action failed and was canceled.<br/>Please review your file for any issues and try again.</>}/>
    }
    return <Result icon={<Spin size="large"/>} title="Uploading..."></Result>
}